<template>
  <div>
    <div class="container-fluid">
      <div
        v-if="isMobile"
        class="row vh-100"
        style="min-height: calc(var(--vh, 1vh) * 100); margin: 0px"
      >
        <div
          class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex d-sm-flex d-md-flex d-md-flex d-lg-flex d-xl-flex justify-content-center text-center align-items-center"
        >
          <div class="row align-items-center">
            <div class="col-12 col-md-12 col-lg-12">
              <span class="text-primary">
                <img
                  src="../../src/assets/img/Saludsa/logo_new_saludsa_vertical.png"
                  style="width: 300px; padding: 10px 25px"
                />
              </span>

              <p
                class="mb-0 text-center"
                style="
                  font-size: 16px;
                  margin-top: 10px;
                  font-weight: 600;
                  color: #0b4b86;
                "
              >
                Gana dinero por referir nuestros planes médicos
              </p>

              <Formulario
                :is-login="isLogin"
                :promo-code="promoCode"
                :texto-button="textoButton"
                v-if="!registerForm"
              />

              <hr class="horizontal dark" style="margin-top: 25px" />

              <a
                target="_blank"
                title="Facebook de Saludsa Refiere y Gana"
                href="https://www.facebook.com/profile.php?id=100090370913056"
              >
                <i class="fab fa-facebook-f redes" aria-hidden="true"></i>
              </a>
              <a
                target="_blank"
                title="Instagram de Saludsa Refiere y Gana"
                href="https://www.instagram.com/"
              >
                <i class="fab fa-instagram redes" aria-hidden="true"></i>
              </a>
              <a
                target="_blank"
                title="Email de Saludsa Refiere y Gana"
                href="mailto:info@planproec.com?Subject=Tengo%20una%20pregunta"
              >
                <i class="fas fa-envelope redes" aria-hidden="true"></i>
              </a>
              <a
                target="_blank"
                title="Tiktok de Saludsa Refiere y Gana"
                href="https://www.tiktok.com/"
              >
                <i class="fa-brands fa-tiktok redes" aria-hidden="true"></i>
              </a>

              <p style="margin-top: 10px; margin-bottom: 0; font-size: 12px">
                <a
                  href="https://firebasestorage.googleapis.com/v0/b/saludsapro.appspot.com/o/legalDocuments%2FTyCs_RefiereyGana_Saludsa_Ecija_rCEV.pdf?alt=media&token=7adbf25f-5531-49ab-b56a-bd0217206fb7"
                  target="_blank"
                  >Términos y condiciones</a
                >
                -
                <a
                  href="https://www.saludsa.com/wp-content/uploads/2026/02/Poli%CC%81tica-de-privacidad.pdf"
                  target="_blank"
                  >Política de privacidad</a
                >
                <!-- -
                <a
                  href="https://firebasestorage.googleapis.com/v0/b/saludsapro.appspot.com/o/legalDocuments%2FAVISO%20LEGAL.pdf?alt=media&token=6626e7a7-e9da-426c-917b-35e9a14b8d5a"
                  target="_blank"
                  >Aviso legal</a
                >-
                <a
                  href="https://firebasestorage.googleapis.com/v0/b/saludsapro.appspot.com/o/legalDocuments%2FDISCLAIMER.pdf?alt=media&token=f1449eb5-6bb2-4866-a8ca-4ffd541191cf"
                  target="_blank"
                  >Disclaimer</a
                > -->
              </p>

              <p style="margin-top: 0px; font-size: 12px; margin-bottom: 10px">
                Copyright &copy; {{ year }}
                <a href="https://referidos.saludsa.com" target="_blank"
                  >- PlanPro</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        v-else
        class="row vh-100"
        style="min-height: calc(var(--vh, 1vh) * 100); margin: 0px"
      >
        <div
          style="padding: 0px; height: 100vh; position: relative"
          class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 d-none d-sm-none d-md-none d-md-none d-lg-none d-xl-flex justify-content-center align-items-center"
        >
          <img
            src="/img/portada-nueva.png"
            style="
              object-fit: cover;
              object-position: left;
              height: 100%;
              width: 100%;
            "
          />
        </div>

        <div
          class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4 d-flex d-sm-flex d-md-flex d-md-flex d-lg-flex d-xl-flex justify-content-center text-center align-items-center"
        >
          <div class="row align-items-center">
            <div class="col-12 col-md-12 col-lg-12">
              <span class="text-primary">
                <img
                  src="../../src/assets/img/Saludsa/logo_new_saludsa_vertical.png"
                  style="width: 300px; padding: 10px 25px"
                />
              </span>

              <p
                class="mb-0 text-center"
                style="
                  font-size: 16px;
                  margin-top: 10px;
                  font-weight: 600;
                  color: #0b4b86;
                "
              >
                Gana dinero por referir nuestros planes médicos
              </p>

              <Formulario
                :is-login="isLogin"
                :promo-code="promoCode"
                :texto-button="textoButton"
                v-if="!registerForm"
              />

              <hr class="horizontal dark" style="margin-top: 25px" />

              <a
                target="_blank"
                title="Facebook de Saludsa Refiere y Gana"
                href="https://www.facebook.com/"
              >
                <i class="fab fa-facebook-f redes" aria-hidden="true"></i>
              </a>
              <a
                target="_blank"
                title="Instagram de Saludsa Refiere y Gana"
                href="https://www.instagram.com/"
              >
                <i class="fab fa-instagram redes" aria-hidden="true"></i>
              </a>
              <a
                target="_blank"
                title="Email de Saludsa Refiere y Gana"
                href="mailto:info@planproec.com?Subject=Tengo%20una%20pregunta"
              >
                <i class="fas fa-envelope redes" aria-hidden="true"></i>
              </a>
              <a
                target="_blank"
                title="Tiktok de Saludsa Refiere y Gana"
                href="https://www.tiktok.com/"
              >
                <i class="fa-brands fa-tiktok redes" aria-hidden="true"></i>
              </a>

              <p style="margin-top: 10px; margin-bottom: 0; font-size: 12px">
                <a
                  href="https://firebasestorage.googleapis.com/v0/b/saludsapro.appspot.com/o/legalDocuments%2FTyCs_RefiereyGana_Saludsa_Ecija_rCEV.pdf?alt=media&token=7adbf25f-5531-49ab-b56a-bd0217206fb7"
                  target="_blank"
                  >Términos y condiciones</a
                >
                -
                <a
                  href="https://www.saludsa.com/wp-content/uploads/2026/02/Poli%CC%81tica-de-privacidad.pdf"
                  target="_blank"
                  >Política de privacidad</a
                >
                <!-- -
                <a
                  href="https://firebasestorage.googleapis.com/v0/b/saludsapro.appspot.com/o/legalDocuments%2FAVISO%20LEGAL.pdf?alt=media&token=6626e7a7-e9da-426c-917b-35e9a14b8d5a"
                  target="_blank"
                  >Aviso legal</a
                >-
                <a
                  href="https://firebasestorage.googleapis.com/v0/b/saludsapro.appspot.com/o/legalDocuments%2FDISCLAIMER.pdf?alt=media&token=f1449eb5-6bb2-4866-a8ca-4ffd541191cf"
                  target="_blank"
                  >Disclaimer</a
                > -->
              </p>

              <p style="margin-top: 0px; font-size: 12px; margin-bottom: 10px">
                Copyright &copy; {{ year }}
                <a href="https://referidos.saludsa.com" target="_blank"
                  >- PlanPro</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Formulario from "./Formulario.vue";

export default {
  name: "Signin",
  components: {
    Formulario,
  },
  data() {
    return {
      isLogin: true,
      promoCode: "",
      textoButton: "",
      registerForm: false,
      year: new Date().getFullYear(),
      isMobile: this.$isMobile,
    };
  },

  mounted() {
    console.log("[Signin] Page loaded with original Bootstrap layout");
    document.title = "Saludsa Refiere y Gana - Inicio de sesión";
  },
};
</script>

<style scoped>
.container-fluid {
  padding: 0px;
  margin: 0px;
}

.loading-content {
  text-align: center;
  padding: 2rem;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.spinner-border {
  width: 3rem;
  height: 3rem;
}

.login-form {
  max-width: 400px;
  margin: 0 auto;
  padding: 0 20px;
}

.btn-login {
  width: 100%;
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: white;
}

.google-btn {
  background: linear-gradient(310deg, #08629e 0%, #0c75ba 100%);
}

.google-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(8, 98, 158, 0.3);
}

.microsoft-btn {
  background: linear-gradient(310deg, #0078d4 0%, #106ebe 100%);
}

.microsoft-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 120, 212, 0.3);
}

.btn-login:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.whatsapp-btn {
  border-radius: 0.5rem;
  width: auto;
  max-width: 220px;
  margin: 10px auto;
  padding: 10px 16px;
  background: #25d366;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: white;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  font-size: 13px;
}

.whatsapp-btn:hover {
  background: #128c7e;
  transform: translateY(-2px);
  color: white;
}

.tooltip-text {
  position: absolute;
  top: -100%;
  left: 150%;
  background-color: #333333;
  color: #fdfdfd;
  padding: 10px;
  border-radius: 8px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 1000;
}

.social-links {
  margin: 20px 0;
}

.social-links a {
  margin: 0 10px;
  color: #666;
  font-size: 20px;
  transition: color 0.3s ease;
}

.social-links a:hover {
  color: #0c75ba;
}
</style>
